<template>
  <div class="Introduce" :class="Introduce.class">
    <div class="main">
      <p class="title">{{Introduce.title}}</p>

      <p class="text" v-for="item,index in Introduce.contents" v-html="item"></p>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Introduce',
  props: ['Introduce'],
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="scss" type="text/scss">
  .Introduce {
    display: flex;
    padding-bottom: 110px;

    .main {
      width: 1050px;
      margin: 0 auto;
      padding: 0 75px;


      p {
        margin: 0;
      }

      .title {
        height:50px;
        font-size:40px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin: 38px 0 60px;
      }

      .text {
        font-size:18px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:33px;
      }
    }
  }
  .FFFFFF {
    background-color: #FFFFFF;
  }
  .F4F4F4 {
    background-color: #F4F4F4;
  }

</style>



// WEBPACK FOOTER //
// src/components/Big_Data/Introduce.vue